import { UserCredential } from "../../Model/User";

export enum ELocalUserAction{
  SAVE_USER = "SAVE_USER",
  ONCHANGE_USER = "ONCHANGE_USER",
  DELETE_USER = "DELETE_USER",
  UPDATE_USER_ACTIVE = "UPDATE_USER_ACTIVE",
}

export interface LocalUserAction {
  type: ELocalUserAction;
  user: UserCredential;
  isActive: boolean;
}

export function saveUserCredential(user?: UserCredential) {
  return {
    type: ELocalUserAction.SAVE_USER,
    user: user
  };
}

export function onChangeUserCredential() {
  return {
    type: ELocalUserAction.ONCHANGE_USER,
  };
}

export function deleteUserCredential() {
  return {
    type: ELocalUserAction.DELETE_USER,
  };
}

export function updateUserActive(active: boolean) {
  return {
    type: ELocalUserAction.UPDATE_USER_ACTIVE,
    isActive: active,
  };
}